// src/Components/Broadcast/services/userService.js
import { collection, getDocs, writeBatch, doc, query, where, limit } from "firebase/firestore";
import { db } from '../../../firebase/firestore';

// Пакетная запись логов для уменьшения количества запросов
const broadcastLogsBatch = [];
let batchTimeout = null;

// Оптимизированное логирование с пакетной обработкой
export const logBroadcast = async (userId, status, message, hasImage = false, error = null, messageType, parseMode) => {
  broadcastLogsBatch.push({
    userId,
    status,
    message: message?.substring(0, 200) || '',
    hasImage,
    error,
    timestamp: new Date().toISOString(),
    type: messageType,
    parseMode
  });

  // Отправляем пачкой каждые 10 записей или через 2 секунды
  if (broadcastLogsBatch.length >= 10) {
    await flushBroadcastLogs();
  } else if (!batchTimeout) {
    batchTimeout = setTimeout(() => flushBroadcastLogs(), 2000);
  }
};

const flushBroadcastLogs = async () => {
  if (broadcastLogsBatch.length === 0) return;
  
  const batch = writeBatch(db);
  const logsToSend = [...broadcastLogsBatch];
  broadcastLogsBatch.length = 0;
  
  if (batchTimeout) {
    clearTimeout(batchTimeout);
    batchTimeout = null;
  }
  
  try {
    for (const log of logsToSend) {
      const logRef = doc(collection(db, "broadcastLogs"));
      batch.set(logRef, log);
    }
    await batch.commit();
  } catch (e) {
    console.error('Ошибка пакетного логирования:', e);
    // В случае ошибки возвращаем логи обратно в очередь
    broadcastLogsBatch.unshift(...logsToSend);
  }
};

// Загрузка пользователей с пагинацией для больших списков
export const fetchUsersPaginated = async (lastDoc = null, pageSize = 100) => {
  const usersRef = collection(db, "telegramUsers");
  let q = query(usersRef, limit(pageSize));
  
  if (lastDoc) {
    q = query(usersRef, where('__name__', '>', lastDoc.id), limit(pageSize));
  }
  
  const snapshot = await getDocs(q);
  const users = snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }));
  
  return {
    users,
    lastDoc: snapshot.docs[snapshot.docs.length - 1]
  };
};

// Расчет статистики (локально, без запросов)
export const calculateStats = (users) => {
  return {
    total: users.length,
    premium: users.filter(u => u.premium).length,
    free: users.filter(u => !u.premium).length,
    auto: users.filter(u => u.premiumActivationType === 'auto').length,
    manual: users.filter(u => u.premiumActivationType === 'manual').length,
    withPhone: users.filter(u => u.phone).length,
    withEmail: users.filter(u => u.email).length
  };
};

// Очистка старых логов (можно запускать раз в день)
export const cleanOldLogs = async (daysToKeep = 30) => {
  const cutoffDate = new Date();
  cutoffDate.setDate(cutoffDate.getDate() - daysToKeep);
  
  const logsRef = collection(db, "broadcastLogs");
  const q = query(logsRef, where("timestamp", "<", cutoffDate.toISOString()), limit(500));
  
  const snapshot = await getDocs(q);
  const batch = writeBatch(db);
  
  snapshot.docs.forEach(doc => {
    batch.delete(doc.ref);
  });
  
  await batch.commit();
  console.log(`Cleaned ${snapshot.size} old logs`);
};